import {
  custom,
  deserialize,
  object,
  optional,
  serializable,
  SKIP,
} from 'serializr';
import { User } from './user.model';
import { Tenant } from './tenant.model';
import { Preference } from './preference.model';
import { UiPreferences } from './ui-preferences';
import { Role } from './role.model';

export class Session {
  @serializable
  public allowAccountJoin: boolean;
  @serializable
  public id: string;
  @serializable(optional(object(User)))
  public user: User;
  @serializable(
    custom(
      () => SKIP,
      (v) => v,
    ),
  )
  public features: string[];
  @serializable(
    custom(
      () => SKIP,
      (v) => v,
    ),
  )
  public uiPreferences: UiPreferences;
  @serializable(optional(object(Tenant)))
  public tenant: Tenant;
  @serializable(optional(object(Preference)))
  public tenantPreference: Preference;
  @serializable
  public serverVersion: string;
  @serializable
  public recorderVersion: string;
  @serializable
  public recorderDownloadEnabled: boolean;
  @serializable
  public enableUserWithDefaultPassword: boolean;
  @serializable(
    custom(
      () => SKIP,
      (v) => v,
    ),
  )
  public publicEmails: string[];
  @serializable(
    custom(
      () => SKIP,
      (v) => v,
    ),
  )
  public fcRestoreId: string;
  @serializable(
    custom(
      () => SKIP,
      (v) => v,
    ),
  )
  public skipOnboarding: boolean;
  @serializable(
    custom(
      () => SKIP,
      (v) => v,
    ),
  )
  public idService: string;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(Session, input));
  }

  public hasFeature = (feature: string) => {
    return this.features.includes(feature);
  };

  get isSpoofing() {
    return this.user?.authType == 'ADMIN_SSO';
  }

  public hasCanShowUserLimitExceededBannerKey = () => {
    return localStorage.getItem('canShowUserLimitExceededBanner');
  };
}
